import headerBackground from './media/mobile-actions.svg';
import qrcode from './media/qr-code.svg';

import iOSBadgeDe from './media/app-store-badge/ios-de.svg';
import iOSBadgeEn from './media/app-store-badge/ios-en.svg';
import iOSBadgeEs from './media/app-store-badge/ios-es.svg';
import iOSBadgeFr from './media/app-store-badge/ios-fr.svg';
import iOSBadgeIt from './media/app-store-badge/ios-it.svg';
import iOSBadgePt from './media/app-store-badge/ios-pt-br.svg';
import iOSBadgeZh from './media/app-store-badge/ios-zh-tw.svg';
import iOSBadgeZhHans from './media/app-store-badge/ios-zh-cn.svg';
import iOSBadgeJa from './media/app-store-badge/ios-ja.svg';


import androidBadgeEn from './media/play-store-badge/en.svg';
import androidBadgeDe from './media/play-store-badge/de.svg';
import androidBadgeEs from './media/play-store-badge/es.svg';
import androidBadgeFr from './media/play-store-badge/fr.svg';
import androidBadgeIt from './media/play-store-badge/it.svg';
import androidBadgePt from './media/play-store-badge/pt-br.svg';
import androidBadgeZh from './media/play-store-badge/zh-tw.svg';
import androidBadgeZhHans from './media/play-store-badge/zh-cn.svg';
import androidBadgeJa from './media/play-store-badge/ja.svg';

// 600px
export const mobileMaxWidth = 600;
export const mobileDevice = `@media (max-width:${mobileMaxWidth}px)`;
export const nonMobileDevice = `@media (min-width:${mobileMaxWidth}px)`;

export const getMobileAppInstallPromptStyles = () => ({
  newUINavigationPreferenceDialog: {
    '&  .ms-Modal-scrollableContent': {
      overflowY: 'initial',
    },
    '& .ms-Dialog-header': {
      height: 198,
      backgroundPositionY: 'bottom',
      backgroundImage: `url("${headerBackground}")`,
      backgroundRepeat: 'no-repeat',
      backgroundColor: '#C7E0F4',
      backgroundSize: 'contain',
      [mobileDevice]: {
        height: 148,
      },
    },

    '& .ms-Dialog-inner': {
      padding: 0,
    },

    '& .ms-Dialog-button--close': {
      color: '#005A9E',
      padding: 'unset',
      width: 'unset',
      height: 'unset',

      '& .ms-Button-flexContainer': {
        width: 'unset',
        height: 'unset',

        '& .ms-Button-icon': {
          margin: 'unset',
        },
      },
    },

    '& .ms-Dialog-button--close:hover, & .ms-Dialog-button--close:active': {
      backgroundColor: '#C7E0F4',
    },

    '& .ms-Dialog-button, .ms-Dialog-button:hover': {
      color: '#0078d4',
      backgroundColor: 'transparent',
    },

    '& .custom-content-wrapper': {
      background: '#0078d4',
      color: '#ffffff',
      padding: 20,

      '& .title': {
        fontWeight: 600,
        fontSize: '20px',
        lineHeight: '27px',
        marginBottom: 14,
        width: 370,
        [mobileDevice]: {
          width: 'auto',
          fontSize: '18px',
        },
      },

      '& .custom-content-text': {

        '& .custom-content-subtitle': {
          width: 370,
          [mobileDevice]: {
            width: 'auto',
          },
        },

        '& .action-call': {
          fontWeight: 600,
          fontSize: '16px',
          lineHeight: '27px',
          marginTop: 20,
          marginBottom: 4,
        },
      },

      '& .custom-content-qr-code-container': {
        background: '#C7E0F4',
        display: 'flex',
        flexDirection: 'row',

        '& .custom-content-qr-code': {
          height: 90,
          width: 90,
          backgroundImage: `url("${qrcode}")`,
          backgroundRepeat: 'no-repeat',
          backgroundColor: '#C7E0F4',
          backgroundSize: 'contain',
          margin: 12,
        },

        '& .custom-content-instructions': {
          alignSelf: 'center',
          fontSize: '14px',
          lineHeight: '24px',
          color: '#323130',
          '& .custom-content-instruction-step': {
          },
        },
      },

      '& .custom-content-badges': {
        display: 'flex',
        flexDirection: 'row',
        marginTop: 24,
        marginBottom: 24,

        '& .custom-content-ios-badge-en': {
          height: 40,
          width: 126,
          backgroundImage: `url("${iOSBadgeEn}")`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundColor: '#0078d4',
          borderWidth: 0,
          borderRadius: 'unset',
        },
        '& .custom-content-ios-badge-fr': {
          height: 40,
          width: 126,
          backgroundImage: `url("${iOSBadgeFr}")`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundColor: '#0078d4',
          borderWidth: 0,
          borderRadius: 'unset',
        },
        '& .custom-content-ios-badge-de': {
          height: 40,
          width: 126,
          backgroundImage: `url("${iOSBadgeDe}")`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundColor: '#0078d4',
          borderWidth: 0,
          borderRadius: 'unset',
        },
        '& .custom-content-ios-badge-es': {
          height: 40,
          width: 126,
          backgroundImage: `url("${iOSBadgeEs}")`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundColor: '#0078d4',
          borderWidth: 0,
          borderRadius: 'unset',
        },
        '& .custom-content-ios-badge-it': {
          height: 40,
          width: 126,
          backgroundImage: `url("${iOSBadgeIt}")`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundColor: '#0078d4',
          borderWidth: 0,
          borderRadius: 'unset',
        },
        '& .custom-content-ios-badge-pt': {
          height: 40,
          width: 126,
          backgroundImage: `url("${iOSBadgePt}")`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundColor: '#0078d4',
          borderWidth: 0,
          borderRadius: 'unset',
        },
        '& .custom-content-ios-badge-zh': {
          height: 40,
          width: 126,
          backgroundImage: `url("${iOSBadgeZh}")`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundColor: '#0078d4',
          borderWidth: 0,
          borderRadius: 'unset',
        },
        '& .custom-content-ios-badge-zh-hans': {
          height: 40,
          width: 126,
          backgroundImage: `url("${iOSBadgeZhHans}")`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundColor: '#0078d4',
          borderWidth: 0,
          borderRadius: 'unset',
        },
        '& .custom-content-ios-badge-ja': {
          height: 40,
          width: 126,
          backgroundImage: `url("${iOSBadgeJa}")`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundColor: '#0078d4',
          borderWidth: 0,
          borderRadius: 'unset',
        },

        '& .custom-content-android-badge-en': {
          height: 40,
          width: 135,
          marginLeft: 13,
          backgroundImage: `url("${androidBadgeEn}")`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundColor: '#0078d4',
          borderWidth: 0,
          borderRadius: 'unset',
        },
        '& .custom-content-android-badge-fr': {
          height: 40,
          width: 135,
          marginLeft: 13,
          backgroundImage: `url("${androidBadgeFr}")`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundColor: '#0078d4',
          borderWidth: 0,
          borderRadius: 'unset',
        },
        '& .custom-content-android-badge-de': {
          height: 40,
          width: 135,
          marginLeft: 13,
          backgroundImage: `url("${androidBadgeDe}")`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundColor: '#0078d4',
          borderWidth: 0,
          borderRadius: 'unset',
        },
        '& .custom-content-android-badge-es': {
          height: 40,
          width: 135,
          marginLeft: 13,
          backgroundImage: `url("${androidBadgeEs}")`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundColor: '#0078d4',
          borderWidth: 0,
          borderRadius: 'unset',
        },
        '& .custom-content-android-badge-it': {
          height: 40,
          width: 135,
          marginLeft: 13,
          backgroundImage: `url("${androidBadgeIt}")`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundColor: '#0078d4',
          borderWidth: 0,
          borderRadius: 'unset',
        },
        '& .custom-content-android-badge-pt': {
          height: 40,
          width: 135,
          marginLeft: 13,
          backgroundImage: `url("${androidBadgePt}")`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundColor: '#0078d4',
          borderWidth: 0,
          borderRadius: 'unset',
        },
        '& .custom-content-android-badge-zh': {
          height: 40,
          width: 135,
          marginLeft: 13,
          backgroundImage: `url("${androidBadgeZh}")`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundColor: '#0078d4',
          borderWidth: 0,
          borderRadius: 'unset',
        },
        '& .custom-content-android-badge-zh-hans': {
          height: 40,
          width: 135,
          marginLeft: 13,
          backgroundImage: `url("${androidBadgeZhHans}")`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundColor: '#0078d4',
          borderWidth: 0,
          borderRadius: 'unset',
        },
        '& .custom-content-android-badge-ja': {
          height: 40,
          width: 135,
          marginLeft: 13,
          backgroundImage: `url("${androidBadgeJa}")`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundColor: '#0078d4',
          borderWidth: 0,
          borderRadius: 'unset',
        },
      },

      '& .panel-footer': {
        padding: 0,
        backgroundColor: '#0078d4',
        borderTop: 'none',

        '& .ms-Dialog-actionsRight': {
          textAlign: 'left',

          '& .btn-link': {
            color: 'white',
            textDecorationLine: 'underline',
            fontWeight: 600,
            fontSize: '14px',
            lineHeight: '19px',
            padding: 0,
          },
        },
      },
    },
  },
  mobileView: {
    display: 'inherit',
    paddingLeft: '50px',
    paddingTop: '200px',
  },
  hideOnWeb: {
    [nonMobileDevice]: {
      display: 'none',
    },
  },
  hide: {
    display: 'none',
  },
  mobileUnderDevelopmentSubtitle: {
    fontSize: '14px',
  },
});
